'use client';

import { useEffect, useState } from 'react';
import { ShieldCheck } from 'lucide-react';
import { Link } from '@/i18n/routing';
import { api } from '@/lib/api';

// Shows a link to the admin panel only for admin/teacher accounts.
export default function AdminLink() {
  const [show, setShow] = useState(false);
  useEffect(() => {
    api
      .me()
      .then((u) => setShow(u.role === 'admin' || u.role === 'teacher'))
      .catch(() => {});
  }, []);

  if (!show) return null;
  return (
    <Link
      href="/admin"
      className="mt-4 flex items-center justify-center gap-2 rounded-xl bg-zinc-100 py-2.5 text-sm font-medium dark:bg-zinc-800"
    >
      <ShieldCheck size={16} /> 管理後台
    </Link>
  );
}
